<!-- Bottom Sheet Content -->
<div [class]="'w-full bg-white rounded-tl-[16px] rounded-tr-[16px] relative mx-auto flex flex-col ' + modalHeight"
     [style.max-height]="!isCalculatorMode ? '90vh' : ''"
     role="dialog" aria-label="Seleccionar tipo de construcción">

    <!-- Header -->
    <div class="px-6 pt-6 pb-4 flex-shrink-0">
      <h3 class="text-center text-[20px] font-semibold font-poppins text-neutral-gray-900 leading-[1.2] m-0">
        {{ getModalTitle() }}
      </h3>
      @if (getModalSubtitle()) {
        <p class="text-center text-[14px] font-normal font-poppins text-neutral-gray-600 mt-2 m-0">
          {{ getModalSubtitle() }}
        </p>
      }
    </div>

    <!-- Close button -->
    <button type="button"
            (click)="close()"
            class="absolute right-[8px] top-[8px] w-[40px] h-[40px] bg-white rounded-full shadow-[0px_0px_4px_0px_rgba(169,188,217,0.05),0px_2px_10px_0px_rgba(0,56,139,0.12)] flex items-center justify-center z-10"
            aria-label="Cerrar">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M17.5 16.1667C17.6667 16.3333 17.75 16.5833 17.75 16.8333C17.75 17.0833 17.6667 17.3333 17.5 17.5C17.4167 17.5833 17.3333 17.6667 17.25 17.6667C17.1667 17.75 17 17.75 16.9167 17.75C16.8333 17.75 16.6667 17.75 16.5833 17.6667C16.5 17.5833 16.4167 17.5833 16.3333 17.5L10 11.3333L3.83333 17.5C3.75 17.5833 3.66667 17.6667 3.58333 17.6667C3.33333 17.75 3.08333 17.75 2.83333 17.6667C2.75 17.6667 2.58333 17.5833 2.5 17.5C2.33333 17.3333 2.25 17.0833 2.25 16.8333C2.25 16.5833 2.33333 16.3333 2.5 16.1667L8.66667 10L2.5 3.83333C2.16667 3.5 2.16667 2.91667 2.5 2.5C2.83333 2.16667 3.41667 2.16667 3.83333 2.5L10 8.66667L16.1667 2.5C16.5 2.16667 17.0833 2.16667 17.5 2.5C17.8333 2.83333 17.8333 3.41667 17.5 3.83333L11.3333 10L17.5 16.1667Z" fill="#20202A"/>
</svg>
    </button>

    <!-- Grid content - Scrolleable en modo quote cuando sea necesario -->
    <div class="flex-1" [class.overflow-hidden]="isCalculatorMode">
      <div 
        class="h-full px-6 pt-2"
        [ngClass]="!isCalculatorMode ? 'pb-[100px]' : 'pb-[48px]'"
        [class.overflow-y-auto]="!isCalculatorMode"
        [class.pb-[120px]]="!isCalculatorMode"
        [style.max-height]="!isCalculatorMode ? 'calc(90vh - 100px)' : null">

        <!-- Loading state -->
        @if (loading) {
          <div class="flex flex-col items-center justify-center py-8" [class.min-h-[200px]]="needsScroll">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-cantera-red-primary mb-4"></div>
            <p class="text-center text-neutral-gray-600 font-poppins">Cargando tipos de trabajo...</p>
          </div>
        }

        <!-- Error state -->
        @if (error && !loading) {
          <div class="flex flex-col items-center justify-center py-8" [class.min-h-[200px]]="needsScroll">
            <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <svg class="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <p class="text-center text-red-600 font-poppins mb-4">{{ error }}</p>
            <button (click)="loadWorkTypes()" class="px-4 py-2 bg-cantera-red-primary text-white rounded-lg font-poppins text-sm">
              Reintentar
            </button>
          </div>
        }

        <!-- Content grid -->
        @if (!loading && !error) {
          <div class="flex flex-wrap justify-center gap-4 w-full">
            @for (type of constructionTypes; track trackByTypeId($index, type)) {
              <ui-button-square
                [iconUrl]="type.iconUrl"
                [title]="type.name"
                [state]="type.selected ? 'selected' : 'unselected'"
                [controlled]="true"
                [size]="'medium'"
                [className]="'w-[148px] h-[142px]'"
                [ariaLabel]="'Seleccionar ' + type.name"
                (clicked)="onConstructionTypeClick(type)">
              </ui-button-square>
            }
          </div>
        }

      </div>
    </div>

    <!-- Bottom fixed button - Solo mostrar en modo quote -->
    @if (!isCalculatorMode) {
      <div class="absolute bottom-0 left-0 right-0 bg-white border-t-2 border-neutral-gray-200 px-6 pb-6 pt-3">

        <!-- Error loading items -->
        @if (itemsError) {
          <div class="mb-3 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p class="text-sm text-red-600 font-poppins text-center">{{ itemsError }}</p>
          </div>
        }

      <!-- Button using ui-button component -->
      <ui-button
        class="w-full"
        [fullWidth]="true"
        [variant]="'primary'"
        [size]="'x-large'"
        [disabled]="!hasSelection || loadingItems"
        [loading]="loadingItems"
        (clicked)="confirm()">
          @if (!loadingItems) {
            <span class="inline-flex items-center gap-2">
              Continuar
              <app-svg-icon 
                [iconName]="hasSelection ? SvgIcon.ARROW_RIGHT : SvgIcon.ARROW_RIGHT_GRAY" 
                [size]="20">
              </app-svg-icon>
            </span>
          }
        </ui-button>
      </div>
    }
  </div>
